import { PureComponent } from 'react'
import Favorite from 'shared/components/favorite/favorite'
import { Actions, trackEvent } from 'shared/util/gif-detail-ga-events'
import styled from 'styled-components'
import { Modals, withGifDetailContext } from '../gif-detail-context'

const Buttons = styled.div`
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
`

const Info = styled.div`
    font-size: 20px;
    height: 36px;
    flex-shrink: 0;
    position: relative;
    transform: rotate(90deg);
    margin-left: 5px;
    margin-right: 20px;
    margin-top: -5px;
`

const FavWrapper = styled.div`
    width: 40px;
    height: 40px;
    margin: -2px 5px 0 0;
`

const Send = styled.div`
    font-size: 20px;
    margin-left: 5px;
    padding: 0 3px;
`

const Edit = styled.div`
    font-size: 20px;
    margin-left: 20px;
    padding: 0 3px;
`

@withGifDetailContext
class Primary extends PureComponent {
    onFavoriteClick = ({ id, is_favorite }) => {
        if (!is_favorite) {
            trackEvent(Actions.favorite, id)
        } else {
            trackEvent(Actions.unfavorite, id)
        }
    }
    onShareClick = () => {
        const {
            setModal,
            gif: { id },
        } = this.props
        setModal(Modals.SHARE)
        trackEvent(Actions.shareClick, id)
    }
    onEditClick = () => {
        const { setModal } = this.props
        setModal(Modals.EDIT)
    }
    onEllipsisClick = () => {
        const {
            setModal,
            gif: { id },
        } = this.props
        setModal(Modals.INFO)
        trackEvent(Actions.ellipsisClick, id)
    }
    render() {
        const {
            gif: { id, is_favorite: isFavorite = false, url },
            loggedInUser = {},
        } = this.props
        return (
            <Buttons>
                <FavWrapper>
                    <Favorite
                        id={id}
                        isFavorite={isFavorite}
                        url={url}
                        showLabel={false}
                        scale={1.3}
                        onClick={this.onFavoriteClick}
                    />
                </FavWrapper>
                <Send className="ss-send" onClick={this.onShareClick} />
                {loggedInUser.isStaff && <Edit className="ss-write" onClick={this.onEditClick} />}
                <Info className="ss-ellipsis" onClick={this.onEllipsisClick} />
            </Buttons>
        )
    }
}

export default Primary
